const getDataFieldsMapData = () => {
  return [
    {
      title: "Point",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "groupByFields",
      itemInArray: true,
    },

    {
      title: "Radius/Color",
      type: "dropzone",
      single: true,
      dataTypeAllowed: "number",
      reduxKey: "valueColumns",
      itemInArray: true,
    },

    {
      title: "Filters",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      queryKey: "Filters",
      reduxKey: "filters",
      itemInArray: true,
    },
    {
      title: "Tooltip",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "rows",
      itemInArray: true,
    },
  ];
};

const getCustomizationMapData = () => {
  return [
    // {
    //   title: "map",
    //   type: "range",
    //   minValue: 1,
    //   maxValue: 100,
    //   reduxKey: "map",
    //   itemInArray: false,
    // },

    // {
    //   title: "Projection",
    //   type: "SELECT_BOX",
    //   defaultValue: { label: "Globe", value: "globe" },
    //   options: [
    //     { label: "Globe", value: "globe" },
    //     { label: "EqualEarth", value: "equalEarth" },
    //     { label: "satellite", value: "satellite" },
    //   ],
    //   reduxKey: "projection",
    //   itemInArray: false,
    // },
    {
      title: "Conditional Formatting",
      type: "CONDITIONAL_FORMATTING",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "conditionalFormatting",
      itemInArray: true,
      defaultValue: [],
    },

    // {
    //   title: "IndiaStateBoundries",
    //   type: "checkbox",
    //   defaultValue: true,
    //   reduxKey: "isBoundryVisible",
    // },
    // {
    //   title: "showHighways",
    //   type: "checkbox",
    //   defaultValue: true,
    //   reduxKey: "showHighways",
    // },
  ];
};

export { getCustomizationMapData, getDataFieldsMapData };
